<app-splash-screen
    *ngIf="isLoading || initializationError"
    [isLoading]="isLoading"
    [hasError]="initializationError"
    (retry)="retryDataInitialization()"
    (goBack)="sendCommand(null)">
</app-splash-screen>

<div *ngIf="!isLoading && !initializationError" class="w-full h-full flex flex-col">
    <ngx-spinner
        name="managementSpinner"
        color="#fff"
        size="medium"
        type="ball-clip-rotate-multiple">
        <p style="font-size: 20px; color: white">Uploading media...</p>
    </ngx-spinner>

    <div *ngIf="totalErrorsCount > 0" class="bg-red-500 text-white px-4 py-2 text-center text-sm font-bold animate-pulse shadow-md z-50 w-full relative">
        ⚠️ You have missing critical data in {{ totalErrorsCount }} section(s). Please review the marked tabs on the side menu.
    </div>

    <mat-sidenav-container class="flex-auto w-full min-h-screen" *ngIf="destination" @zoomIn>
        <mat-sidenav #sidenav
                     class="w-64 border-r dark:bg-gray-900"
                     [autoFocus]="false"
                     [mode]="(isHandset | async) ? 'over' : 'side'"
                     [opened]="(isHandset | async) === false">

            <div class="flex items-center h-16 px-6 border-b">
                <span class="ml-2 text-lg font-bold">Management</span>
            </div>

            <mat-nav-list (click)="isHandsetValue && sidenav.close()">

                <ng-container *ngIf="reviewNavItems.length > 0">
                    <h3 matSubheader class="text-red-600 font-bold tracking-wider uppercase mt-2 mb-2 px-6 flex items-center">
                        <mat-icon class="mr-2 icon-size-5">warning</mat-icon> Review Data
                    </h3>
                    <a mat-list-item *ngFor="let item of reviewNavItems" [activated]="selectedView === item.id" (click)="selectView(item.id)" class="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 mb-1">
                        <mat-icon matListItemIcon class="text-red-500">{{ item.icon }}</mat-icon>
                        <span matListItemTitle class="text-red-600 dark:text-red-400 font-semibold">{{ item.label }}</span>
                        <span matListItemMeta class="flex items-center justify-center">
                            <mat-icon class="text-red-500 animate-pulse">error</mat-icon>
                        </span>
                    </a>
                    <mat-divider class="my-4"></mat-divider>
                </ng-container>

                <h3 matSubheader class="px-6 font-semibold" *ngIf="reviewNavItems.length > 0">General Navigation</h3>

                <a mat-list-item *ngIf="userUiType === 4" [activated]="selectedView === 'dashboard'" (click)="selectView('dashboard')">
                    <mat-icon matListItemIcon>home</mat-icon>
                    <span matListItemTitle>Home</span>
                </a>

                <a  *ngIf="userUiType === 4"
                    mat-list-item
                    href="https://app.gohighlevel.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                >
                    <mat-icon matListItemIcon>share</mat-icon>
                    <span matListItemTitle>Portal Partner</span>
                </a>

                <mat-divider class="my-2" *ngIf="userUiType === 4"></mat-divider>

                <a mat-list-item *ngIf="!hasHomeErrors()" [activated]="selectedView === 'home'" (click)="selectView('home')">
                    <mat-icon matListItemIcon>home</mat-icon>
                    <span matListItemTitle *ngIf="userUiType !== 4">Home</span>
                    <span matListItemTitle *ngIf="userUiType === 4">Edit Profile</span>
                </a>

                <a mat-list-item *ngIf="!hasMainMediaErrors()" [activated]="selectedView === 'main-media'" (click)="selectView('main-media')">
                    <mat-icon matListItemIcon>image</mat-icon>
                    <span matListItemTitle>Main Media</span>
                </a>

                <a mat-list-item [activated]="selectedView === 'features'" (click)="selectView('features')">
                    <mat-icon matListItemIcon>star_outline</mat-icon>
                    <span matListItemTitle *ngIf="userUiType !== 4">Features</span>
                    <span matListItemTitle *ngIf="userUiType === 4">Languages</span>
                </a>

                <a mat-list-item *ngIf="!hasMapErrors()" [activated]="selectedView === 'map'" (click)="selectView('map')">
                    <mat-icon matListItemIcon>map</mat-icon>
                    <span matListItemTitle>Map</span>
                </a>

                <a mat-list-item *ngIf="!hasGalleryErrors()" [activated]="selectedView === 'gallery'" (click)="selectView('gallery')">
                    <mat-icon matListItemIcon>collections</mat-icon>
                    <span matListItemTitle>Gallery</span>
                </a>

                <ng-container *ngIf="userUiType !== 4">
                    <mat-divider class="my-2"></mat-divider>
                    <h3 matSubheader>Translation</h3>
                    <a mat-list-item [activated]="selectedView === 'translation-settings'" (click)="selectView('translation-settings')">
                        <mat-icon matListItemIcon>translate</mat-icon>
                        <span matListItemTitle>Translations Settings</span>
                    </a>
                </ng-container>

                <ng-container *ngIf="userUiType !== 4">
                    <mat-divider class="my-2"></mat-divider>
                    <h3 matSubheader>Auditing</h3>
                    <a mat-list-item [activated]="selectedView === 'history'" (click)="selectView('history')">
                        <mat-icon matListItemIcon>history</mat-icon>
                        <span matListItemTitle>History</span>
                        <span *ngIf="pendingReviewCount > 0"
                              matListItemMeta
                              class="mr-2 px-2 h-5 leading-5 bg-amber-500 text-white text-xs rounded-full flex items-center justify-center font-semibold">
                        {{ pendingReviewCount }}
                    </span>
                    </a>
                </ng-container>

                <mat-divider class="my-2" *ngIf="destination_relationships?.length > 0"></mat-divider>
                <h3 matSubheader *ngIf="destination_relationships?.length > 0">Relationships</h3>
                <a mat-list-item *ngFor="let rel of destination_relationships"
                   [activated]="selectedView === 'relationship_' + rel.ds_en_dependencytype"
                   (click)="selectView('relationship_' + rel.ds_en_dependencytype)">
                    <mat-icon matListItemIcon>link</mat-icon>
                    <span matListItemTitle>{{ rel.ds_en_dependencytype }}</span>
                </a>

                <mat-divider class="my-2" *ngIf="destination.ar_storriesgrouped?.length > 0"></mat-divider>
                <h3 matSubheader *ngIf="destination.ar_storriesgrouped?.length > 0">Stories</h3>
                <a mat-list-item *ngFor="let tab of destination.ar_storriesgrouped"
                   [activated]="selectedView === 'story_' + tab.ds_grouplabel"
                   (click)="selectView('story_' + tab.ds_grouplabel)">
                    <mat-icon matListItemIcon>history_edu</mat-icon>
                    <span matListItemTitle>{{ tab.ds_grouplabel }}</span>
                </a>

                <mat-divider class="my-2" *ngIf="destination.bl_offers && !offersValidationStatus"></mat-divider>
                <a mat-list-item *ngIf="destination.bl_offers && !offersValidationStatus"
                   [activated]="selectedView === 'offers'" (click)="selectView('offers')">
                    <mat-icon matListItemIcon>local_offer</mat-icon>
                    <span matListItemTitle>{{ destination.ds_destinationtype === 'Ambassador' ? 'Tours' : 'Special Offers' }}</span>
                </a>

                <mat-divider class="my-2" *ngIf="destination.ar_products?.length > 0"></mat-divider>
                <h3 matSubheader *ngIf="destination.ar_products?.length > 0">Products</h3>
                <a mat-list-item *ngFor="let tab of destination.ar_products"
                   [activated]="selectedView === 'product_' + tab.ds_title_producttype"
                   (click)="selectView('product_' + tab.ds_title_producttype)">
                    <mat-icon matListItemIcon>shopping_bag</mat-icon>
                    <span matListItemTitle>{{ tab.ds_title_producttype }}</span>
                </a>

                <ng-container *ngIf="!reviewMode">
                    <mat-divider class="my-2" *ngIf="clientData"></mat-divider>
                    <a mat-list-item *ngIf="clientData"
                       [activated]="selectedView === 'client'" (click)="selectView('client')">
                        <mat-icon matListItemIcon>business</mat-icon>
                        <span matListItemTitle>Client Information</span>
                    </a>
                </ng-container>
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content class="flex flex-col bg-gray-50 dark:bg-transparent">
            <mat-toolbar class="sticky top-0 z-10 shadow-md px-4 md:px-8">
                <button mat-icon-button *ngIf="(isHandset | async)" (click)="sidenav.toggle()" class="mr-2">
                    <mat-icon>menu</mat-icon>
                </button>

                <div class="flex-shrink-0 mr-4 px-2.5 py-1 text-xs font-semibold rounded-full"
                     [ngClass]="{
             'bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-300': destination.ds_en_state === 'Published',
             'bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300': destination.ds_en_state === 'Review',
             'bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-300': destination.ds_en_state === 'Draft',
             'bg-gray-200 text-gray-800 dark:bg-gray-600 dark:text-gray-200': !['Published', 'Review', 'Draft'].includes(destination.ds_en_state)
         }">
                    {{ destination.ds_en_state }}
                </div>

                <div class="flex flex-col truncate">
                    <span class="text-lg md:text-xl font-semibold truncate">{{ destination.ds_title }}</span>
                    <span class="text-sm text-secondary truncate" *ngIf="destination.vi_linkedproperties > 0">
                    Linked with {{ destination.vi_linkedproperties }} properties
                </span>
                </div>

                <span *ngIf="reviewMode"
                      class="ml-4 px-3 py-1 rounded-full bg-amber-500 text-white text-sm font-semibold hidden sm:inline">In Review</span>
                <span class="flex-auto"></span>

                <button *ngIf="!reviewMode && adminMode" mat-stroked-button (click)="sendCommand(null)" class="mr-2">
                    Back
                </button>
                <div *ngIf="!reviewMode" class="hidden md:flex items-center space-x-2">
                    <button mat-stroked-button (click)="onNavigate()" matTooltip="Preview Destination">
                        <mat-icon>visibility</mat-icon>
                    </button>

                    <button mat-icon-button [matMenuTriggerFor]="moreActionsMenu" matTooltip="More actions">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #moreActionsMenu="matMenu">
                        <button mat-menu-item *ngIf="userUiType === 3" (click)="cloneDestination()">
                            <mat-icon>content_copy</mat-icon>
                            <span>Clone</span>
                        </button>
                        <button mat-menu-item (click)="togglePublish()">
                            <mat-icon>unpublished</mat-icon>
                            <span>Unpublish</span>
                        </button>
                        <button mat-menu-item *ngIf="userUiType === 2 || userUiType === 3" (click)="deleteDestination()" color="warn">
                            <mat-icon color="warn">delete</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>

                    <button mat-flat-button
                            color="primary"
                            (click)="sendToReview()"
                            [class.highlight-flash]="highlightReviewButton">
                        Publish
                    </button>
                </div>

                <button *ngIf="reviewMode" mat-stroked-button (click)="sendCommand(null)" class="mr-2">Back</button>
                <div *ngIf="reviewMode" class="items-center space-x-2">
                    <button mat-stroked-button (click)="onNavigate()" matTooltip="Preview Destination">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-stroked-button color="warn" [disabled]="commentInputControl.invalid"
                            (click)="reviewAction('reject')">Reject
                    </button>
                    <button mat-flat-button color="primary" (click)="reviewAction('approve')">Approve</button>
                </div>

                <div class="flex md:hidden">
                    <button mat-icon-button [matMenuTriggerFor]="mobileActionsMenu" matTooltip="More actions"
                            [class.highlight-flash]="highlightReviewButton">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #mobileActionsMenu="matMenu">
                        <ng-container *ngIf="!reviewMode">
                            <button mat-menu-item (click)="onNavigate()">
                                <mat-icon>visibility</mat-icon>
                                <span>Preview</span>
                            </button>
                            <button mat-menu-item
                                    (click)="sendToReview()"
                                    [class.highlight-flash]="highlightReviewButton">
                                <mat-icon>rate_review</mat-icon>
                                <span>Publish</span>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="reviewMode">
                            <button mat-menu-item (click)="reviewAction('approve')">
                                <mat-icon>check_circle</mat-icon>
                                <span>Approve</span>
                            </button>
                            <button mat-menu-item color="warn" [disabled]="commentInputControl.invalid"
                                    (click)="reviewAction('reject')">
                                <mat-icon color="warn">cancel</mat-icon>
                                <span>Reject</span>
                            </button>
                        </ng-container>
                    </mat-menu>
                </div>

            </mat-toolbar>

            <div *ngIf="reviewMode" class="p-4 border-b bg-amber-50 dark:bg-gray-800">
                <mat-form-field class="w-full" appearance="fill">
                    <mat-label>Review Comment</mat-label>
                    <textarea matInput rows="2" [required]="true" [formControl]="commentInputControl"
                              placeholder="Provide feedback for the rejection or approval..."></textarea>
                </mat-form-field>
            </div>

            <div class="flex-auto p-4 md:p-8 overflow-y-auto" [ngSwitch]="selectedView">
                <project *ngSwitchCase="'dashboard'"></project>

                <app-home-tab *ngSwitchCase="'home'" [destination]="destination" [adminMode]="adminMode"
                              [reviewMode]="reviewMode" [destinationTypesArray]="destinationTypesArray"
                              (save)="saveAndClose(false, 'home-tab')" (reload)="saveAndReload($event)"
                              (parentChange)="handleParentChange($event)"></app-home-tab>

                <app-destination-main-media *ngSwitchCase="'main-media'" [destination]="destination"
                                            [reviewMode]="reviewMode">
                </app-destination-main-media>

                <app-features-tab *ngSwitchCase="'features'" [destination]="destination" [reviewMode]="reviewMode"
                                  (save)="saveAndClose(false, 'features-tab')"></app-features-tab>

                <app-map-tab *ngSwitchCase="'map'" [destination]="destination"
                             [reviewMode]="reviewMode" (save)="saveAndClose(false, 'map-tab')"></app-map-tab>

                <app-gallery-tab *ngSwitchCase="'gallery'" [destination]="destination"
                                 [reviewMode]="reviewMode"></app-gallery-tab>

                <app-translation-settings *ngSwitchCase="'translation-settings'"
                                          [destination]="destination"
                                          [reviewMode]="reviewMode"
                                          (save)="saveAndClose(false, 'translation-settings')">
                </app-translation-settings>

                <ng-container *ngFor="let rel of destination_relationships">
                    <app-destination-relationship-manager
                        *ngSwitchCase="'relationship_' + rel.ds_en_dependencytype"
                        [id_destination]="destination.id_destination"
                        [dependencyType]="rel.ds_en_dependencytype"
                        [en_dependencyType]="rel.en_dependencytype"
                        [itemsList]="rel.ar_items || []">
                    </app-destination-relationship-manager>
                </ng-container>

                <ng-container *ngFor="let tab of destination.ar_storriesgrouped">
                    <app-stories-tab *ngSwitchCase="'story_' + tab.ds_grouplabel" [storyGroup]="tab"
                                     [destinationId]="destination.id_destination" [reviewMode]="reviewMode"
                                     (save)="saveAndClose(false, 'stories-tab')"></app-stories-tab>
                </ng-container>

                <special-offers-list *ngSwitchCase="'offers'" [reviewMode]="reviewMode" [fromProperty]="true"
                                     [destination]="destination"
                                     [destination_ID]="destination.id_destination"></special-offers-list>

                <ng-container *ngFor="let tab of destination.ar_products">
                    <app-products-tab *ngSwitchCase="'product_' + tab.ds_title_producttype" [productGroup]="tab"
                                      [destinationId]="destination.id_destination" [reviewMode]="reviewMode"
                                      (save)="saveAndClose(false, 'products-tab')"></app-products-tab>
                </ng-container>

                <ng-container *ngIf="!reviewMode">
                    <app-destination-client-manager *ngSwitchCase="'client'" [clientData]="clientData"
                                                    [managersList]="managerData"
                                                    [id_destination]="destination.id_destination"></app-destination-client-manager>
                </ng-container>

                <ng-container *ngIf="userUiType !== 4">
                    <app-change-history *ngSwitchCase="'history'" [history]="destination_ar_history"></app-change-history>
                </ng-container>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
